import type { QueryStatus } from '@tanstack/query-core';
import type { ParsedUrlQuery } from 'querystring';

import { QueryCoreStatus } from 'Types/queryCoreStatus';

import { DEFAULT_FILTER_PAIRS, EXCLUDED_FILTERS } from './VehicleListEmptyState.consts';

export const generateObjectsArray = (count: number): Array<{ id: number }> =>
	Array.from(Array(count), (_, index) => ({
		id: index,
	}));

export const countValidQueryFilters = (query: ParsedUrlQuery, filteredPairs = DEFAULT_FILTER_PAIRS): number => {
	const filteredKeys = Object.entries(filteredPairs).filter(([key, value]) => String(query[key]) === String(value));

	const validKeys = Object.keys(query).filter((key) => {
		if ([null, undefined, ''].includes(query[key] as string) || EXCLUDED_FILTERS.includes(key)) {
			return false;
		}

		return !filteredKeys.some(([filteredKey]) => filteredKey === key);
	});

	return validKeys.length;
};

export const isViewLoading = (queryStatus: QueryStatus, isPreviousData?: boolean): boolean =>
	queryStatus === QueryCoreStatus.Loading || !!isPreviousData;

export const isViewEmpty = (queryStatus: QueryStatus, rowsCount?: number): boolean =>
	queryStatus === QueryCoreStatus.Success && rowsCount === 0;

export const isViewEmptyFilters = (isEmpty: boolean, filtersQuery: ParsedUrlQuery): boolean =>
	isEmpty && countValidQueryFilters(filtersQuery) > 0;

export const isViewError = (queryStatus: QueryStatus): boolean => queryStatus === QueryCoreStatus.Error;
